module.exports = __webpack_public_path__ + "img/0-08.fb0e098d.jpg";